export default __webpack_public_path__ + "static/ak-cached/24h/media/black-friday2020-flash-sale-dropdown-open.4c2899b2.png";